function href(a) {
  if (!a || typeof a !== "string") {
    throw new Error(`Invalid href`);
  }
  return a;
}
export {
  href
};
//# sourceMappingURL=href.js.map
